import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "lard";

function GILard() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GILard;